import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DriveStep, Driver, driver } from 'driver.js';

export const driverBase = driver({
  showProgress: true,
  allowClose: false,
  animate: true,
  disableActiveInteraction: true,
  popoverOffset: 15,
  smoothScroll: true,
  showButtons: ['next', 'previous', 'close'],
  doneBtnText: 'Hecho',
  nextBtnText: 'Siguiente',
  prevBtnText: 'Atrás',
  progressText: '{{current}} de {{total}}',
  onPopoverRender: (popover, { config, state }) => {
    if (driverBase.isLastStep()) return;

    const exitButton = document.createElement("button");
    exitButton.innerText = "Salir";
    popover.footerButtons.prepend(exitButton);
    exitButton.addEventListener("click", () => {
      driverBase.destroy();
    });
  },
});

export enum TutorialSteps {
  CREAR_OT,
  CREAR_VENTA,
  SIDEBAR,
  CREAR_SERVICIO,
  CREAR_PRODUCTO,
  INDEX_OT,
  INDEX_VENTA,
  INDEX_COTIZACIONES,
  FLUJO_OT,
  INDEX_ITEM_CHECKLIST,
  INDEX_ITEM_CERTIFICADO_MANTENIMIENTO,
  INDEX_RECEPCION_VEHICULO,
  INDEX_VEHICULOS,
  INDEX_SERVICIOS,
  INDEX_CERTIFICADO_MANTENIMIENTO,
};

export const indexVentaSteps = (driver: Driver): DriveStep[] => {
  return [
    {
      element: '.registrar-venta-tutorial',
      popover: {
        title: 'Punto de Venta',
        description: `
          ● Crea una nueva venta solo de Productos.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '#filtros',
      popover: {
        title: 'Filtros de Ventas',
        description: `
          ● Filtra utilizando los campos que estimes necesarios.
        `,
        side: "top",
        align: 'center',
        onNextClick: (element, step, options) => {
          const i = driver.getActiveIndex();
          if (!i) return;
          const steps = driver.getConfig().steps;
          if (!steps) return;
          const selectorNextStep = steps[i + 1].element;
          if (!selectorNextStep) return;
          const filtrosElement = typeof selectorNextStep !== 'string' ? (selectorNextStep as HTMLElement) : document.querySelector<HTMLElement>(selectorNextStep);
          if (!filtrosElement) {
            driver.moveTo(i + 2);
            return;
          }
          driver.moveNext();
        }
      },
    },
    {
      element: '#filtros .btns',
      popover: {
        title: 'Filtrar y exportar',
        description: `
          ● <span class="fw-bold">Limpiar filtros: </span> Borra los filtros de búsquedas aplicados. <br>
          ● <span class="fw-bold">Aplicar filtros: </span> Aplica los filtros para que el sistema muestre la información deseada. <br>
          ● <span class="fw-bold">Descargar Excel: </span> Exporta la información de acuerdo a los filtros aplicados previamente. <br>
        `,
        side: "left",
        align: 'center',

      },
    },
    {
      element: '.kuv-lazy-table .grid',
      popover: {
        title: 'Lista de Ventas',
        description: `
          ● Administra todas las Ventas de productos registradas.
        `,
        side: "top",
        align: 'center',
        onPrevClick: (element, step, options) => {
          const i = driver.getActiveIndex();
          if (!i) return;
          const steps = driver.getConfig().steps;
          if (!steps) return;
          const selectorPrevStep = steps[i - 1].element;
          if (!selectorPrevStep) return;
          const filtrosElement = typeof selectorPrevStep !== 'string' ? (selectorPrevStep as HTMLElement) : document.querySelector<HTMLElement>(selectorPrevStep);
          if (!filtrosElement) {
            driver.moveTo(i - 2);
            return;
          }
          driver.movePrevious();
        }
      },
    },
    {
      element: '.kuv-lazy-table .grid .acciones-list',
      popover: {
        title: 'Acciones de OT',
        description: `
          ● <span class="fw-bold">Ver:</span> Visualiza el perfil de la Venta. <br>
          ● <span class="fw-bold">Editar:</span> Actualiza la información de la Venta. <br>
          ● <span class="fw-bold">Documento:</span> Descarga en PDF el documento y la envía al correo de tu cliente. <br>
          ● <span class="fw-bold">Eliminar:</span> Elimina una Venta del sistema y repone los productos al inventario. <br>
        `,
        side: "left",
        align: 'center',

      },
    },
  ]
};

export const indexCotizacionSteps = (driver: Driver): DriveStep[] => {
  return [
    {
      element: '.registrar-cotizacion-tutorial',
      popover: {
        title: 'Cotizaciones',
        description: `
          ● Crea una nueva cotización para luego pasarla a OT, Venta o Recepción de Vehículo.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '#filtros',
      popover: {
        title: 'Filtros de Cotizaciones',
        description: `
          ● Filtra utilizando los campos que estimes necesarios.
        `,
        side: "top",
        align: 'center',
        onNextClick: (element, step, options) => {
          const i = driver.getActiveIndex();
          if (!i) return;
          const steps = driver.getConfig().steps;
          if (!steps) return;
          const selectorNextStep = steps[i + 1].element;
          if (!selectorNextStep) return;
          const filtrosElement = typeof selectorNextStep !== 'string' ? (selectorNextStep as HTMLElement) : document.querySelector<HTMLElement>(selectorNextStep);
          if (!filtrosElement) {
            driver.moveTo(i + 2);
            return;
          }
          driver.moveNext();
        }
      },
    },
    {
      element: '#filtros .btns',
      popover: {
        title: 'Filtrar y exportar',
        description: `
          ● <span class="fw-bold">Limpiar filtros: </span> Borra los filtros de búsquedas aplicados. <br>
          ● <span class="fw-bold">Aplicar filtros: </span> Aplica los filtros para que el sistema muestre la información deseada. <br>
          ● <span class="fw-bold">Descargar Excel: </span> Exporta la información de acuerdo a los filtros aplicados previamente. <br>
        `,
        side: "left",
        align: 'center',

      },
    },
    {
      element: '.kuv-lazy-table .grid',
      popover: {
        title: 'Lista de Cotizaciones',
        description: `
          ● Administra todas las Cotizaciones registradas y visualize su estado.
        `,
        side: "top",
        align: 'center',
        onPrevClick: (element, step, options) => {
          const i = driver.getActiveIndex();
          if (!i) return;
          const steps = driver.getConfig().steps;
          if (!steps) return;
          const selectorPrevStep = steps[i - 1].element;
          if (!selectorPrevStep) return;
          const filtrosElement = typeof selectorPrevStep !== 'string' ? (selectorPrevStep as HTMLElement) : document.querySelector<HTMLElement>(selectorPrevStep);
          if (!filtrosElement) {
            driver.moveTo(i - 2);
            return;
          }
          driver.movePrevious();
        }
      },
    },
    {
      element: '.kuv-lazy-table .grid .acciones-list',
      popover: {
        title: 'Acciones de Cotizaciones',
        description: `
          ● <span class="fw-bold">Ver:</span> Visualiza la información de la Cotización. <br>
          ● <span class="fw-bold">Editar:</span> Actualiza la información de la Cotización. <br>
          ● <span class="fw-bold">Documento:</span> Descarga en PDF el documento y la envía al correo de tu cliente. <br>
          ● <span class="fw-bold">Eliminar:</span> Elimina una Cotización del sistema. <br>
          ● <span class="fw-bold">Pasar a OT:</span> Convierte una Cotización a Orden de Trabajo. <br>
          ● <span class="fw-bold">Pasar a Venta:</span> Convierte una Cotización a Venta. <br>
          ● <span class="fw-bold">Pasar a Recepción de Vehículo:</span> Convierte una Cotización a Recepción de Vehículo. <br>
          ● <span class="fw-bold">Pasar a Orden de Compra:</span> Convierte una Cotización a una Orden de Compra. <br>
        `,
        side: "left",
        align: 'center',

      },
    },
  ]
};

export const indexRecepcionVehiculoSteps = (driver: Driver): DriveStep[] => {
  return [
    {
      element: '.registrar-recepcion-vehiculo-tutorial',
      popover: {
        title: 'Recepción de Vehículo',
        description: `
          ● Crea una nueva Recepción de Vehículo. Se permite convertirla a una OT.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '#filtros',
      popover: {
        title: 'Filtros de Recepción de Vehículo',
        description: `
          ● Filtra utilizando los campos que estimes necesarios.
        `,
        side: "top",
        align: 'center',
        onNextClick: (element, step, options) => {
          const i = driver.getActiveIndex();
          if (!i) return;
          const steps = driver.getConfig().steps;
          if (!steps) return;
          const selectorNextStep = steps[i + 1].element;
          if (!selectorNextStep) return;
          const filtrosElement = typeof selectorNextStep !== 'string' ? (selectorNextStep as HTMLElement) : document.querySelector<HTMLElement>(selectorNextStep);
          if (!filtrosElement) {
            driver.moveTo(i + 2);
            return;
          }
          driver.moveNext();
        }
      },
    },
    {
      element: '#filtros .btns',
      popover: {
        title: 'Filtrar y exportar',
        description: `
          ● <span class="fw-bold">Limpiar filtros: </span> Borra los filtros de búsquedas aplicados. <br>
          ● <span class="fw-bold">Aplicar filtros: </span> Aplica los filtros para que el sistema muestre la información deseada. <br>
          ● <span class="fw-bold">Descargar Excel: </span> Exporta la información de acuerdo a los filtros aplicados previamente. <br>
        `,
        side: "left",
        align: 'center',

      },
    },
    {
      element: '.kuv-lazy-table .grid',
      popover: {
        title: 'Lista de Recepción de Vehículo',
        description: `
          ● Administra todas las Recepciones de Vehículos registradas y visualize su estado.
        `,
        side: "top",
        align: 'center',
        onPrevClick: (element, step, options) => {
          const i = driver.getActiveIndex();
          if (!i) return;
          const steps = driver.getConfig().steps;
          if (!steps) return;
          const selectorPrevStep = steps[i - 1].element;
          if (!selectorPrevStep) return;
          const filtrosElement = typeof selectorPrevStep !== 'string' ? (selectorPrevStep as HTMLElement) : document.querySelector<HTMLElement>(selectorPrevStep);
          if (!filtrosElement) {
            driver.moveTo(i - 2);
            return;
          }
          driver.movePrevious();
        }
      },
    },
    {
      element: '.kuv-lazy-table .grid .acciones-list',
      popover: {
        title: 'Acciones de Recepción de Vehículo',
        description: `
          ● <span class="fw-bold">Ver:</span> Visualiza la información de la Recepción de Vehículo. <br>
          ● <span class="fw-bold">Editar:</span> Actualiza la información de la Recepción de Vehículo. <br>
          ● <span class="fw-bold">Descargar:</span> Descarga en PDF el documento y la envía al correo de tu cliente. <br>
          ● <span class="fw-bold">Eliminar:</span> Elimina una Recepción de Vehículo del sistema. <br>
          ● <span class="fw-bold">Pasar a OT:</span> Convierte una Recepción de Vehículo a Orden de Trabajo. <br>
          ● <span class="fw-bold">Ver Cotización:</span> Permite visualizar la información de la Cotización original de cual proviene la Recepción de Vehículo. <br>
        `,
        side: "left",
        align: 'center',

      },
    },
  ]
};


export const indexVehiculosSteps = (driver: Driver): DriveStep[] => {
  return [
    {
      element: '.registrar-vehiculo-tutorial',
      popover: {
        title: 'Registrar Vehículo',
        description: `
          ● Registra un nuevo Vehículo en el sistema.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.registrar-vehiculo-masivo-tutorial',
      popover: {
        title: 'Subida masiva de Vehículos',
        description: `
          ● Carga múltiples Vehículos en el sistema desde un archivo Excel.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '#filtros',
      popover: {
        title: 'Filtros de Vehículos',
        description: `
          ● Filtra utilizando los campos que estimes necesarios.
        `,
        side: "top",
        align: 'center',
        onNextClick: (element, step, options) => {
          const i = driver.getActiveIndex();
          if (!i) return;
          const steps = driver.getConfig().steps;
          if (!steps) return;
          const selectorNextStep = steps[i + 1].element;
          if (!selectorNextStep) return;
          const filtrosElement = typeof selectorNextStep !== 'string' ? (selectorNextStep as HTMLElement) : document.querySelector<HTMLElement>(selectorNextStep);
          if (!filtrosElement) {
            driver.moveTo(i + 2);
            return;
          }
          driver.moveNext();
        }
      },
    },
    {
      element: '#filtros .btns',
      popover: {
        title: 'Filtrar y exportar',
        description: `
          ● <span class="fw-bold">Limpiar filtros: </span> Borra los filtros de búsquedas aplicados. <br>
          ● <span class="fw-bold">Aplicar filtros: </span> Aplica los filtros para que el sistema muestre la información deseada. <br>
          ● <span class="fw-bold">Descargar Excel: </span> Exporta la información de acuerdo a los filtros aplicados previamente. <br>
        `,
        side: "left",
        align: 'center',

      },
    },
    {
      element: '.kuv-lazy-table .grid',
      popover: {
        title: 'Lista de Vehículos',
        description: `
          ● Administra todos los vehículos registrados en el sistema.
        `,
        side: "top",
        align: 'center',
        onPrevClick: (element, step, options) => {
          const i = driver.getActiveIndex();
          if (!i) return;
          const steps = driver.getConfig().steps;
          if (!steps) return;
          const selectorPrevStep = steps[i - 1].element;
          if (!selectorPrevStep) return;
          const filtrosElement = typeof selectorPrevStep !== 'string' ? (selectorPrevStep as HTMLElement) : document.querySelector<HTMLElement>(selectorPrevStep);
          if (!filtrosElement) {
            driver.moveTo(i - 2);
            return;
          }
          driver.movePrevious();
        }
      },
    },
    {
      element: '.kuv-lazy-table .grid .acciones-list',
      popover: {
        title: 'Acciones de Vehículos',
        description: `
          ● <span class="fw-bold">Ver:</span> Visualiza la información del Vehículo. <br>
          ● <span class="fw-bold">Ver OTs:</span> Visualiza todas las Órdenes de Trabajo asociadas al Vehículo. <br>
          ● <span class="fw-bold">Editar:</span> Actualiza la información del Vehículo. <br>
          ● <span class="fw-bold">Activar/Desactivar:</span> Activa o Desactiva la visualización del Vehículo en diferentes secciones del sistema. <br>
          ● <span class="fw-bold">Eliminar:</span> Elimina un vehículo del sistema. <br>
        `,
        side: "left",
        align: 'center',

      },
    },
  ]
};

export const indexItemChecklistSteps = (driver: Driver): DriveStep[] => {
  return [
    {
      element: '.registrar-item-checklist-tutorial',
      popover: {
        title: 'Item Checklist',
        description: `
          ● Crea un Item de Checklist para ser utilizado en la Recepción de Vehículo.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '#filtros',
      popover: {
        title: 'Filtros de Item Checklist',
        description: `
          ● Filtra utilizando los campos que estimes necesarios.
        `,
        side: "top",
        align: 'center',
        onNextClick: (element, step, options) => {
          const i = driver.getActiveIndex();
          if (!i) return;
          const steps = driver.getConfig().steps;
          if (!steps) return;
          const selectorNextStep = steps[i + 1].element;
          if (!selectorNextStep) return;
          const filtrosElement = typeof selectorNextStep !== 'string' ? (selectorNextStep as HTMLElement) : document.querySelector<HTMLElement>(selectorNextStep);
          if (!filtrosElement) {
            driver.moveTo(i + 2);
            return;
          }
          driver.moveNext();
        }
      },
    },
    {
      element: '#filtros .btns',
      popover: {
        title: 'Filtrar y exportar',
        description: `
          ● <span class="fw-bold">Limpiar filtros: </span> Borra los filtros de búsquedas aplicados. <br>
          ● <span class="fw-bold">Aplicar filtros: </span> Aplica los filtros para que el sistema muestre la información deseada. <br>
          ● <span class="fw-bold">Descargar Excel: </span> Exporta la información de acuerdo a los filtros aplicados previamente. <br>
        `,
        side: "left",
        align: 'center',

      },
    },
    {
      element: '.kuv-lazy-table .grid',
      popover: {
        title: 'Lista de Item Checklist',
        description: `
          ● Administra todos los Item Checklist registrados.
        `,
        side: "top",
        align: 'center',
        onPrevClick: (element, step, options) => {
          const i = driver.getActiveIndex();
          if (!i) return;
          const steps = driver.getConfig().steps;
          if (!steps) return;
          const selectorPrevStep = steps[i - 1].element;
          if (!selectorPrevStep) return;
          const filtrosElement = typeof selectorPrevStep !== 'string' ? (selectorPrevStep as HTMLElement) : document.querySelector<HTMLElement>(selectorPrevStep);
          if (!filtrosElement) {
            driver.moveTo(i - 2);
            return;
          }
          driver.movePrevious();
        }
      },
    },
    {
      element: '.kuv-lazy-table .grid .acciones-list',
      popover: {
        title: 'Acciones de Item Checklist',
        description: `
          ● <span class="fw-bold">Ver:</span> Visualiza la información del Item Checklist. <br>
          ● <span class="fw-bold">Editar:</span> Actualiza la información del Item Checklist. <br>
          ● <span class="fw-bold">Eliminar:</span> Elimina el Item Checklist del sistema. <br>
        `,
        side: "left",
        align: 'center',

      },
    },
  ]
};

export const indexItemCertificadoMantenimientoSteps = (driver: Driver): DriveStep[] => {
  return [
    {
      element: '.registrar-item-certificado-mantenimiento-tutorial',
      popover: {
        title: 'Item Certificado de Mantenimiento',
        description: `
          ● Crea un Item de Certificado de Mantenimiento para ser utilizado en la generación de Certificado de Mantenimiento realizado.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '#filtros',
      popover: {
        title: 'Filtros de Item Certificado de Mantenimiento',
        description: `
          ● Filtra utilizando los campos que estimes necesarios.
        `,
        side: "top",
        align: 'center',
        onNextClick: (element, step, options) => {
          const i = driver.getActiveIndex();
          if (!i) return;
          const steps = driver.getConfig().steps;
          if (!steps) return;
          const selectorNextStep = steps[i + 1].element;
          if (!selectorNextStep) return;
          const filtrosElement = typeof selectorNextStep !== 'string' ? (selectorNextStep as HTMLElement) : document.querySelector<HTMLElement>(selectorNextStep);
          if (!filtrosElement) {
            driver.moveTo(i + 2);
            return;
          }
          driver.moveNext();
        }
      },
    },
    {
      element: '#filtros .btns',
      popover: {
        title: 'Filtrar y exportar',
        description: `
          ● <span class="fw-bold">Limpiar filtros: </span> Borra los filtros de búsquedas aplicados. <br>
          ● <span class="fw-bold">Aplicar filtros: </span> Aplica los filtros para que el sistema muestre la información deseada. <br>
          ● <span class="fw-bold">Descargar Excel: </span> Exporta la información de acuerdo a los filtros aplicados previamente. <br>
        `,
        side: "left",
        align: 'center',

      },
    },
    {
      element: '.kuv-lazy-table .grid',
      popover: {
        title: 'Lista de Item Certificado de Mantenimiento',
        description: `
          ● Administra todos los Item Certificado de Mantenimiento registrados.
        `,
        side: "top",
        align: 'center',
        onPrevClick: (element, step, options) => {
          const i = driver.getActiveIndex();
          if (!i) return;
          const steps = driver.getConfig().steps;
          if (!steps) return;
          const selectorPrevStep = steps[i - 1].element;
          if (!selectorPrevStep) return;
          const filtrosElement = typeof selectorPrevStep !== 'string' ? (selectorPrevStep as HTMLElement) : document.querySelector<HTMLElement>(selectorPrevStep);
          if (!filtrosElement) {
            driver.moveTo(i - 2);
            return;
          }
          driver.movePrevious();
        }
      },
    },
    {
      element: '.kuv-lazy-table .grid .acciones-list',
      popover: {
        title: 'Acciones de Item Certificado de Mantenimiento',
        description: `
          ● <span class="fw-bold">Ver:</span> Visualiza la información del Item Certificado de Mantenimiento. <br>
          ● <span class="fw-bold">Editar:</span> Actualiza la información del Item Certificado de Mantenimiento. <br>
          ● <span class="fw-bold">Eliminar:</span> Elimina el Item Certificado de Mantenimiento del sistema. <br>
        `,
        side: "left",
        align: 'center',

      },
    },
  ]
};

export const indexOTSteps = (driver: Driver): DriveStep[] => {
  return [
    {
      element: '.registrar-orden-tutorial',
      popover: {
        title: 'Registrar Nueva OT',
        description: `
          ● Crear una nueva OT.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.flujo-ot-tutorial',
      popover: {
        title: 'Flujo OT',
        description: `
          ● Puedes ver las OT separadas por estados.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.revisiones-por-renovar-tutorial',
      popover: {
        title: 'Revisiones por renovar',
        description: `
          ● Puedes ver un listado o calendario de las próximas mantenciones.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.revisiones-calendario-tutorial',
      popover: {
        title: 'Calendario de OTs',
        description: `
          ● Puedes ver en formato calendario las revisiones calendarizadas.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '#filtros',
      popover: {
        title: 'Filtros OT',
        description: `
          ● Filtra utilizando los campos que estimes necesarios.
        `,
        side: "top",
        align: 'center',
        onNextClick: (element, step, options) => {
          const i = driver.getActiveIndex();
          if (!i) return;
          const steps = driver.getConfig().steps;
          if (!steps) return;
          const selectorNextStep = steps[i + 1].element;
          if (!selectorNextStep) return;
          const filtrosElement = typeof selectorNextStep !== 'string' ? (selectorNextStep as HTMLElement) : document.querySelector<HTMLElement>(selectorNextStep);
          if (!filtrosElement) {
            driver.moveTo(i + 3);
            return;
          }
          driver.moveNext();
        }
      },
    },
    {
      element: '#filtros .btns',
      popover: {
        title: 'Filtrar y exportar',
        description: `
          ● <span class="fw-bold">Limpiar filtros: </span> Borra los filtros de búsquedas aplicados. <br>
          ● <span class="fw-bold">Aplicar filtros: </span> Aplica los filtros para que el sistema muestre la información deseada. <br>
          ● <span class="fw-bold">Descargar Excel: </span> Exporta la información de acuerdo a los filtros aplicados previamente. <br>
        `,
        side: "left",
        align: 'center',
      },
    },
    {
      element: '.kuv-lazy-table .grid',
      popover: {
        title: 'Lista de OT',
        description: `
          ● Administra todas las OT registradas con sus respectivos estados.
        `,
        side: "top",
        align: 'center',
        onPrevClick: (element, step, options) => {
          const i = driver.getActiveIndex();
          if (!i) return;
          const steps = driver.getConfig().steps;
          if (!steps) return;
          const selectorPrevStep = steps[i - 1].element;
          if (!selectorPrevStep) return;
          const filtrosElement = typeof selectorPrevStep !== 'string' ? (selectorPrevStep as HTMLElement) : document.querySelector<HTMLElement>(selectorPrevStep);
          if (!filtrosElement) {
            driver.moveTo(i - 3);
            return;
          }
          driver.movePrevious();
        }
      },
    },
    {
      element: '.kuv-lazy-table .grid .acciones-list',
      popover: {
        title: 'Acciones de OT',
        description: `
          ● <span class="fw-bold">Ver:</span> Visualiza el perfil de la OT. <br>
          ● <span class="fw-bold">Editar:</span> Actualiza la información de la OT. <br>
          ● <span class="fw-bold">Adjuntos:</span> Carga imágenes o archivos PDF a la OT. <br>
          ● <span class="fw-bold">Estado:</span> Cambia el estado de una OT a "Pendiente", "En Proceso", "Completada". <br>
          ● <span class="fw-bold">Documento:</span> Descarga en PDF el documento y la envía al correo de tu cliente. <br>
          ● <span class="fw-bold">Eliminar:</span> Elimina una OT del sistema y repone los productos al inventario. <br>
        `,
        side: "left",
        align: 'center',

      },
    },
  ]
};

export const indexFlujoOTSteps = (driver: Driver): DriveStep[] => {
  return [
    {
      element: '.flujo-ot-tutorial',
      popover: {
        title: 'Flujo OT',
        description: `
          ● Gestione su Orden de Trabajo en base a las tareas y estados. <br>
          ● Filtre en base a las OT's diarias, semanales o mensuales.
        `,
        side: "right",
        align: 'start',
      },
    },
  ]
};

export const crearOTSteps = (driver: Driver): DriveStep[] => {
  return [
    {
      element: '.seccion-detalles-tutorial',
      popover: {
        title: 'Detalles',
        description: `
          ● Debe rellenar los campos no opcionales.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.vehiculo-tutorial',
      popover: {
        title: 'Vehículo',
        description: `
          ● Puede seleccionar su vehículo. <br>
          ● Puede editar un vehículo seleccionado. <br>
          ● Puede crear un nuevo vehículo. <br>`,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.cliente-tutorial',
      popover: {
        title: 'Cliente',
        description: `
          ● Puede seleccionar su cliente. <br>
          ● Puede editar un cliente seleccionado. <br>
          ● Puede crear un nuevo cliente.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.seccion-venta-tutorial',
      popover: {
        title: 'Ventas',
        description: `
          ● Sección para agregar servicios/productos.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.crear-productos-tutorial',
      popover: {
        title: 'Crear',
        description: `
          ● Puede crear productos y/o servicios.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.cargar-fotos-vehiculo-tutorial',
      popover: {
        title: 'Cargar archivos',
        description: `
          ● Puede cargar imágenes y/o archivos de su vehículo.
        `,
        side: 'left',
        align: 'start',
      }
    },
    {
      element: '.agregar-productos-tutorial',
      popover: {
        title: 'Agregar Productos',
        description: `
          ● Para agregar productos a su venta.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.cambiar-descuento-tutorial',
      popover: {
        title: 'Tipo de Descuento',
        description: `
          ● El descuento puede ser por pesos o por % al hacer click en este botón.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.descuento-tutorial',
      popover: {
        title: 'Descuento',
        description: `
          ● Puede agregar un descuento al bruto de la venta.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.tipo-documento-tutorial',
      popover: {
        title: 'Tipo de Documento',
        description: `
          ● Las cotizaciones no descuentan stock de inventario.
        `,
      },
    },
    {
      element: '.metodo-pago-tutorial',
      popover: {
        title: 'Método de Pago',
        description: `
          ● Deshabilitado en las cotizaciones.
        `,
      },
    },
    {
      element: '.registrar-venta-tutorial',
      popover: {
        title: 'Registrar Orden de Trabajo',
        description: `
          ● Guarda su orden de trabajo en el sistema.
        `,
      },
    },
  ];
};

export const crearVentaSteps = (driver: Driver): DriveStep[] => {
  return [
    {
      element: '.seccion-detalles-tutorial',
      popover: {
        title: 'Detalles',
        description: `
          ● Debe rellenar los campos no opcionales.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.cliente-tutorial',
      popover: {
        title: 'Cliente',
        description: `
          ● Puede seleccionar su cliente. <br>
          ● Puede editar un cliente seleccionado. <br>
          ● Puede crear un nuevo cliente.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.seccion-venta-tutorial',
      popover: {
        title: 'Ventas',
        description: `
          ● Sección para agregar productos.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.crear-productos-tutorial',
      popover: {
        title: 'Crear',
        description: `
          ● Puede crear nuevos productos.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.agregar-productos-tutorial',
      popover: {
        title: 'Agregar Productos',
        description: `
          ● Para agregar productos a su venta.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.descuento-tutorial',
      popover: {
        title: 'Descuento',
        description: `
          ● Puede agregar un descuento al bruto de la venta.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.cambiar-descuento-tutorial',
      popover: {
        title: 'Tipo de Descuento',
        description: `
          ● El descuento puede ser por pesos o por % al hacer click en este botón.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.tipo-documento-tutorial',
      popover: {
        title: 'Tipo de Documento',
        description: `
          ● Las cotizaciones no descuentan stock de inventario.
        `,
      },
    },
    {
      element: '.metodo-pago-tutorial',
      popover: {
        title: 'Método de Pago',
        description: `
          ● Deshabilitado en las cotizaciones.
        `,
      },
    },
    {
      element: '.registrar-venta-tutorial',
      popover: {
        title: 'Registrar Venta',
        description: `
          ● Para guardar su venta.
        `,
      },
    },
  ];
};

export const sidebarSteps = (driver: Driver): DriveStep[] => {
  return [
    {
      element: 'kuv-sidebar-item:has(.fas.fa-chart-bar)',
      popover: {
        title: 'Reportes de Ventas',
        description: `
          ● Puede visualizar los reportes de su sistema.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: 'kuv-sidebar-item:has(.fas.fa-car)',
      popover: {
        title: 'Taller',
        description: `
          ● Órdenes de Trabajo. <br>
          ● Flujo OT. <br>
          ● Vehículos y Servicios.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: 'kuv-sidebar-item:has(.fas.fa-boxes)',
      popover: {
        title: 'Inventario',
        description: `
          ● Productos y Categorías. <br>
          ● Stock Crítico. <br>
          ● Ajustes de Stock.
        `,
        side: "right",
        align: 'start',
      },
    },
  ];
};

export const indexServicioSteps = (driver: Driver): DriveStep[] => {
  return [
    {
      element: '.agregar-servicio-tutorial',
      popover: {
        title: 'Registrar Servicio',
        description: `
          ● Registra un nuevo Servicio en el sistema.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.agregar-servicio-masivo-tutorial',
      popover: {
        title: 'Subida Masiva de Servicios',
        description: `
          ● Registra múltiples Servicios de manera masiva desde un archivo Excel.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.actualizar-servicio-masivo-tutorial',
      popover: {
        title: 'Actualización Masiva de Servicios',
        description: `
          ● Actualiza múltiples Servicios de manera masiva desde un archivo Excel.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.eliminacion-servicio-masivo-tutorial',
      popover: {
        title: 'Eliminación Masiva de Servicios',
        description: `
          ● Elimina <b>todos</b> los Servicios del sistema.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '#filtros .btns',
      popover: {
        title: 'Filtrar y exportar',
        description: `
          ● <span class="fw-bold">Limpiar filtros: </span> Borra los filtros de búsquedas aplicados. <br>
          ● <span class="fw-bold">Aplicar filtros: </span> Aplica los filtros para que el sistema muestre la información deseada. <br>
          ● <span class="fw-bold">Descargar Excel: </span> Exporta la información de acuerdo a los filtros aplicados previamente. <br>
        `,
        side: "left",
        align: 'center',

      },
    },
    {
      element: '.kuv-lazy-table .grid',
      popover: {
        title: 'Lista de Servicios',
        description: `
          ● Administra todos los Servicios registradas con sus respectivos estados.
        `,
        side: "top",
        align: 'center',
        onPrevClick: (element, step, options) => {
          const i = driver.getActiveIndex();
          if (!i) return;
          const steps = driver.getConfig().steps;
          if (!steps) return;
          const selectorPrevStep = steps[i - 1].element;
          if (!selectorPrevStep) return;
          const filtrosElement = typeof selectorPrevStep !== 'string' ? (selectorPrevStep as HTMLElement) : document.querySelector<HTMLElement>(selectorPrevStep);
          if (!filtrosElement) {
            driver.moveTo(i - 3);
            return;
          }
          driver.movePrevious();
        }
      },
    },
    {
      element: '.kuv-lazy-table .grid .acciones-list',
      popover: {
        title: 'Acciones de Servicios',
        description: `
          ● <span class="fw-bold">Ver:</span> Visualiza la información del Servicio. <br>
          ● <span class="fw-bold">Editar:</span> Actualiza la información del Servicio. <br>
          ● <span class="fw-bold">Estadísticas App:</span> Configure el estado de disponibilidad del servicio en la app móvil Lubrikuv (disponible sólo en plan Turbo). <br>
          ● <span class="fw-bold">Estado App:</span> Acceda a las estadísticas del servicio en la app móvil Lubrikuv (disponible sólo en plan Turbo). <br>
          ● <span class="fw-bold">Activar/Desactivar:</span> Activa o Desactiva la visualización del Servicio en diferentes secciones del sistema. <br>
        `,
        side: "left",
        align: 'center',

      },
    },
  ];
};

export const crearServicioSteps = (driver: Driver, activeModal: NgbModal): DriveStep[] => {
  return [
    {
      element: '.agregar-servicio-tutorial',
      popover: {
        title: 'Agregar Servicio',
        description: `
          ● Para agregar un nuevo servicio.
        `,
        side: "right",
        align: 'start',
        onNextClick: (element, step, options) => {
          (document.querySelector('.agregar-servicio-tutorial') as HTMLButtonElement)?.click();
          setTimeout(() => {
            driver.moveNext();
          }, 0);
        },
      },
    },
    {
      element: '.nombre-servicio-tutorial',
      popover: {
        title: 'Nombre del Servicio',
        description: `
          ● Obligatorio.
        `,
        side: "right",
        align: 'start',
        onPrevClick: () => {
          activeModal.dismissAll();
          driver.movePrevious();
        }
      },
    },
  ];
};

export const crearProductoSteps = (driver: Driver, activeModal: NgbModal): DriveStep[] => {
  return [
    {
      element: '.agregar-producto-tutorial',
      popover: {
        title: 'Agregar Producto',
        description: `
          ● Para agregar un nuevo producto.
        `,
        onNextClick: (element, step, options) => {
          (document.querySelector('.agregar-producto-tutorial') as HTMLButtonElement)?.click();
          setTimeout(() => {
            driver.moveNext();
          }, 0);
        },
        align: 'start',
      },
    },
    {
      element: '.nombre-producto-tutorial',
      popover: {
        title: 'Nombre del Producto',
        description: `
          ● El nombre del producto es obligatorio.
        `,
        side: "right",
        align: 'start',
        onPrevClick: () => {
          activeModal.dismissAll();
          driver.movePrevious();
        },
        onNextClick: () => {
          driver.moveNext();
        }
      },
    },
    {
      element: '.precio-venta-tutorial',
      popover: {
        title: 'Precio de Venta',
        description: `
          ● Al ingresar un precio, se calcula el otro tras hacer click afuera.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.precio-compra-tutorial',
      popover: {
        title: 'Precio de Compra',
        description: `
          ● Al ingresar un precio, se calcula el otro tras hacer click afuera.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.stock-inicial-tutorial',
      popover: {
        title: 'Stock Inicial',
        description: `
          ● (Opcional) Se asigna el stock cuando se crea una sucursal .
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.stock-minimo-tutorial',
      popover: {
        title: 'Stock Mínimo',
        description: `
          ● (Opcional) Para resaltar con rojo si el stock es inferior.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '.imagen-tutorial',
      popover: {
        title: 'Imagen',
        description: `
          ● (Opcional) Imagen del producto .
        `,
        side: "right",
        align: 'start',
      },
    },
  ];
};


export const indexCertificadoMantenimientoSteps = (driver: Driver): DriveStep[] => {
  return [
    {
      element: '.registrar-certificado-mantenimiento-tutorial',
      popover: {
        title: 'Certificado de Mantenimiento',
        description: `
          ● Crea un nuevo certificado de mantenimiento asociado a un vehículo y OT.
        `,
        side: "right",
        align: 'start',
      },
    },
    {
      element: '#filtros',
      popover: {
        title: 'Filtros de Certificados',
        description: `
          ● Filtra utilizando los campos que estimes necesarios.
        `,
        side: "top",
        align: 'center',
        onNextClick: (element, step, options) => {
          const i = driver.getActiveIndex();
          if (!i) return;
          const steps = driver.getConfig().steps;
          if (!steps) return;
          const selectorNextStep = steps[i + 1].element;
          if (!selectorNextStep) return;
          const filtrosElement = typeof selectorNextStep !== 'string' ? (selectorNextStep as HTMLElement) : document.querySelector<HTMLElement>(selectorNextStep);
          if (!filtrosElement) {
            driver.moveTo(i + 2);
            return;
          }
          driver.moveNext();
        }
      },
    },
    {
      element: '#filtros .btns',
      popover: {
        title: 'Filtrar y exportar',
        description: `
          ● <span class="fw-bold">Limpiar filtros: </span> Borra los filtros de búsquedas aplicados. <br>
          ● <span class="fw-bold">Aplicar filtros: </span> Aplica los filtros para que el sistema muestre la información deseada. <br>
          ● <span class="fw-bold">Descargar Excel: </span> Exporta la información de acuerdo a los filtros aplicados previamente. <br>
        `,
        side: "left",
        align: 'center',

      },
    },
    {
      element: '.kuv-lazy-table .grid',
      popover: {
        title: 'Lista de Certificados de Mantenimiento',
        description: `
          ● Administra todos los Certificados de Mantenimiento registrados.
        `,
        side: "top",
        align: 'center',
        onPrevClick: (element, step, options) => {
          const i = driver.getActiveIndex();
          if (!i) return;
          const steps = driver.getConfig().steps;
          if (!steps) return;
          const selectorPrevStep = steps[i - 1].element;
          if (!selectorPrevStep) return;
          const filtrosElement = typeof selectorPrevStep !== 'string' ? (selectorPrevStep as HTMLElement) : document.querySelector<HTMLElement>(selectorPrevStep);
          if (!filtrosElement) {
            driver.moveTo(i - 2);
            return;
          }
          driver.movePrevious();
        }
      },
    },
    {
      element: '.kuv-lazy-table .grid .acciones-list',
      popover: {
        title: 'Acciones de Certificado de Mantenimiento',
        description: `
          ● <span class="fw-bold">Ver:</span> Visualiza el perfil del Certificado de Mantenimiento. <br>
          ● <span class="fw-bold">Editar:</span> Actualiza la información del Certificado de Mantenimiento. <br>
          ● <span class="fw-bold">Documento:</span> Descarga en PDF el documento y la envía al correo de tu cliente. <br>
          ● <span class="fw-bold">Eliminar:</span> Elimina un Certificado de Mantenimiento del sistema. <br>
        `,
        side: "left",
        align: 'center',

      },
    },
  ]
};